




























































































































































































import ProductInfo from '@/components/order/mixins/OrderProductInfo.ts';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import DeliveryCell from '@/components/order/detail/DeliveryCell.vue'
import LayerPopup from '@/components/LayerPopup.vue';

@Component({
  components: {
    CompSelectBox,
    DeliveryCell,
    LayerPopup
  },
})
export default class OrderProductInfo extends Mixins(ProductInfo) {
  @Prop({required: true})
  private escrowPayType: boolean;

  @Prop({required: true})
  public taskMessageInfo: any;
  
  private showFreeGiftBrokenNotice = false;

  private mounted(): void {
    this.getOrderProductInfo();
  }

  public showClaimDetailBtn(type: any): any {
    // if (this.showClaimDetailBtnTypeArr.indexOf(type) > -1) {//之后查看
    if (type) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 기존코드가 productInfo 갯수를 돌면서 테이블을 그린다. 이때 병합되어있는 배송번호 아이템을 가져오는 메서드
   * 기존 코드 변수명 그대로 파라미터로 넘김
   * @param shippingResp : 배송번호별 아이템 같다
   * @param item : productInfo(배열) 1개
   * @private
   */
  private getShippingResp(shippingResp: any[], item: any){
    return shippingResp.find(shipping => shipping.shippingNo === item.shippingNo)
  }
  
  private isBrokenFreeGiftCondition(item) {
    return item.freeGiftConditionBrokenType === 'CLAIM_DONE'
  }
  
  private toggleFreeGiftBrokenNotice() {
    this.showFreeGiftBrokenNotice = !this.showFreeGiftBrokenNotice;
  }
}
